<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">検収日入力</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
					<tbody>
						<ShowDetailRecord
							:columnName="'出荷日'"
							:value="'2023/05/01'"
							:tdStyle="{ backgroundColor: 'white', border: '1px solid whitesmoke' }"
						/>
						<ShowDetailRecord :columnName="'検収日'">
							<template v-slot:value>
								<v-menu
									:close-on-content-click="false"
									transition="scale-transition"
									offset-y
									min-width="auto"
								>
									<template v-slot:activator="{ on, attrs }">
										<v-text-field
											v-model="acceptanceInspectionDate"
											clearable
											outlined
											background-color="white"
											hide-details
											dense
											readonly
											v-bind="attrs"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker
										v-model="acceptanceInspectionDate"
										no-title
										scrollable
										locale="ja-JP"
									/>
								</v-menu>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :columnName="'検収連絡書類'">
							<template v-slot:value>
								<v-btn dark color="secondary" @click="$refs.uploadFile.click()">
									<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
									添付する
									<input
										type="file"
										class="d-none"
										ref="uploadFile"
										@change="addFiles($event)"
										multiple
									/>
								</v-btn>
								<div class="mt-2">
									<span v-if="files.length < 1" class="filename">選択されていません</span>
									<template v-else>
										<v-chip
											class="ma-1 mt-2"
											close
											label
											outlined
											color="primary"
											@click:close="removeFile(i)"
											v-for="(file, i) in files"
											:key="file.name"
										>
											<v-icon class="mr-1">mdi-paperclip</v-icon>
											{{ file.name }}
										</v-chip>
									</template>
								</div>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
				<v-row no-gutters class="mt-4" justify="center">
					<ConfirmationDialog :confirm_options="confirm_options" requireBtn @accept="updateMatter">
						<template v-slot:open-btn-content>
							<v-icon class="mr-1">mdi-content-save-outline</v-icon>
							上記の内容で保存する
						</template>
						<template v-slot:text>
							<p>
								検収入力を確定させますが、よろしいですか。
								<br />
								※入力後の修正は棚卸後はできなくなります。
							</p>
						</template>
					</ConfirmationDialog>
				</v-row>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import ConfirmationDialog from "../../shared/ConfirmationDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		matter: {
			type: Object,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
		ConfirmationDialog,
	},
	data() {
		return {
			confirmationDialog: false,
			valid: false,
			common,
			rules,
			acceptanceInspectionDate: null,
			files: [],
			confirm_options: {
				title: "検収日入力",
				accept_text: "確定",
				cancel_text: "戻る",
			},
		}
	},
	methods: {
		updateMatter() {
			// TODO
			const headers = authenticate.setHeader()
			const url = ``
			const params = {}
			axios
				.put(url, params, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
					this.confirmationDialog = false
					this.$emit("update-matter", res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.files.push(file[1])
			})
		},
		removeFile(index) {
			this.files.splice(index, 1)
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>